import React from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import NoScript from '../NoScript';
import { useLazyLoading } from './useLazyLoading';

type ImgProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export interface Props {
  innerRef?: (node: HTMLImageElement | null) => void;
}

const LazyLoadingImage: React.FC<Props & ImgProps> = ({ children, innerRef, ...props }) => {
  const { enableLazyLoading, supportsNativeLazy, ref, inView } = useLazyLoading();
  const isMounted = useIsMounted();

  if (!enableLazyLoading || supportsNativeLazy) {
    return <img alt="" loading="lazy" ref={innerRef} {...props} />;
  }

  return (
    <>
      {!isMounted && (
        <NoScript>
          <img alt="" {...props} />
        </NoScript>
      )}
      <div ref={ref}>
        {inView ? (
          <img
            ref={node => {
              innerRef && innerRef(node);
            }}
            alt=""
            loading="lazy"
            {...props}
          />
        ) : (
          <svg
            width={props.width}
            height={props.height}
            style={props.style}
            data-hook={props['data-hook']}
          />
        )}
      </div>
    </>
  );
};
LazyLoadingImage.displayName = 'LazyLoadingImage';

export default React.memo(LazyLoadingImage);
